import LayoutContainer from 'components/Common/LayoutContainer'
import Group from 'components/utils/Group'
import HeadingTextBlock from 'LuxKit/TextBlocks/HeadingTextBlock'
import React from 'react'
import Sheet from 'components/utils/Sheet'
import BodyText from 'LuxKit/Typography/BodyText'
import ResponsiveImage from 'components/Common/ResponsiveImage'
import Heading from 'LuxKit/Typography/Heading'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import styled from 'styled-components'
import { rem } from 'polished'
import TripLandingAnimatedBackground from 'tripPlanner/Tripkit/TripLandingAnimatedBackground'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { FormattedMessage } from 'react-intl'

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: ${rem(32)};
  
  ${mediaQueryUp.tablet} {
    grid-template-columns: repeat(3, 1fr);
  }
`
const StyledSheet = styled(Sheet)`
  display: grid;
  grid-template: "content" 1fr / 1fr;
  position: relative;
`

const StyledTripLandingAnimatedBackground = styled(TripLandingAnimatedBackground)`
  grid-area: content;
  position: absolute;
  top: ${rem(-48)};
  left: 0;
  right: 0;
  bottom: ${rem(-48)};
  z-index: 0;
`

const ContentContainer = styled.div`
  grid-area: content;
  position: relative;
  z-index: 1;
`
const StyledSheetTransparent = styled(Sheet)`
  background: rgba(255,255,255, 0.16);
`

function TripLandingPageHowItWorks() {
  return (
    <StyledSheet paletteType="inverse" padding="48 0" background="neutral-eight">
      <StyledTripLandingAnimatedBackground />
      <ContentContainer>
        <LayoutContainer>
          <Group direction="vertical" verticalAlign="center" horizontalAlign="center" gap={32}>
            <HeadingTextBlock variant="heading2">
              <FormattedMessage
                id="sQVcFwYEbX"
                defaultMessage="How it <i>works</i>"
                description="Heading for how it works section"
                values={{
                  i: (chunks: React.ReactNode) => <i key="italic">{chunks}</i>,
                }}
              />
            </HeadingTextBlock>
            <GridContainer>
              <StyledSheetTransparent
                paletteType="inverse"
                padding="24 20"
                borderRadius="L"
              >
                <Group direction="vertical" horizontalAlign="center" gap={12}>
                  <ResponsiveImage id="wu92zsltjcbuyq7qoo4a" width={80} height={80} />
                  <VerticalSpacer gap={4}>
                    <Group direction="vertical" horizontalAlign="center" gap={4}>
                      <Heading variant="heading5" align="center">
                        <FormattedMessage
                          id="tVpBSOwtw8"
                          defaultMessage="Tell us about your trip"
                          description="Heading for tell us about your trip section"
                        />
                      </Heading>
                      <BodyText variant="large" align="center">
                        <FormattedMessage
                          id="jd7vtcyPty"
                          defaultMessage="Choose your destination, travel dates, and what kind of experience you’re after."
                          description="Description for tell us about your trip section"
                        />
                      </BodyText>
                    </Group>
                  </VerticalSpacer>
                </Group>

              </StyledSheetTransparent>
              <StyledSheetTransparent
                paletteType="inverse"
                padding="24 20"
                borderRadius="L"
              >
                <Group direction="vertical" horizontalAlign="center" gap={12}>
                  <ResponsiveImage id="msgvpmjw9gcv9i48elto" width={80} height={80} />
                  <VerticalSpacer gap={4}>
                    <Group direction="vertical" horizontalAlign="center" gap={4}>
                      <Heading variant="heading5" align="center">
                        <FormattedMessage
                          id="5+XDdb3rMk"
                          defaultMessage="We build your itinerary instantly"
                          description="Heading for we build your itinerary instantly section"
                        />
                      </Heading>
                      <BodyText variant="large" align="center">
                        <FormattedMessage
                          id="506y29QBZV"
                          defaultMessage="Our smart AI, guided by travel experts builds a personalised, bookable trip just for you."
                          description="Description for our smart AI, guided by travel experts builds a personalised, bookable trip just for you section"
                        />
                      </BodyText>
                    </Group>
                  </VerticalSpacer>
                </Group>
              </StyledSheetTransparent>
              <StyledSheetTransparent
                paletteType="inverse"
                padding="24 20"
                borderRadius="L"
              >
                <Group direction="vertical" horizontalAlign="center" gap={12}>
                  <ResponsiveImage id="2qma9scdehdx12s2dd9m" width={80} height={80} />
                  <VerticalSpacer gap={4}>
                    <Group direction="vertical" horizontalAlign="center" gap={4}>
                      <Heading variant="heading5" align="center">
                        <FormattedMessage
                          id="cDZlEPwhU3"
                          defaultMessage="Tweak, share and book"
                          description="Heading for tweak, share and book section"
                        />
                      </Heading>
                      <BodyText variant="large" align="center">
                        <FormattedMessage
                          id="RMzY0Du1Bz"
                          defaultMessage="Change anything you like, share with others, and travel stress-free with every detail in one place."
                          description="Description for tweak, share and book section"
                        />
                      </BodyText>
                    </Group>
                  </VerticalSpacer>
                </Group>
              </StyledSheetTransparent>
            </GridContainer>
          </Group>
        </LayoutContainer>
      </ContentContainer>
    </StyledSheet>
  )
}

export default TripLandingPageHowItWorks
